import { Model, Attr, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Price } from './';

@Model()
export default class Product extends ApplicationRecord {
  static jsonapiType = 'products';

  static scopeFactory() {
    return Product.includes([]);
  }

  @Attr() name: string;
  @Attr() description: string;
  @Attr() metadata: { codename: string };

  @HasMany() prices: Price[];
}
